import { render, staticRenderFns } from "./OrganizerSettingCard.vue?vue&type=template&id=16574bb5&scoped=true"
import script from "./OrganizerSettingCard.vue?vue&type=script&lang=js"
export * from "./OrganizerSettingCard.vue?vue&type=script&lang=js"
import style0 from "./OrganizerSettingCard.vue?vue&type=style&index=0&id=16574bb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16574bb5",
  null
  
)

export default component.exports